@import url(https://fonts.geckoform.com/satoshi.css);

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  body {
    font-family: "Satoshi-Gecko", sans-serif;
    font-feature-settings: "salt";
  }
}